import React from 'react';

import { FarmOffer } from 'common/components/farm';
import useStyles from './farm-details.styles';

const FarmDetails = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <FarmOffer />
    </div>
  );
};

export default FarmDetails;
